import { FieldArray } from 'formik';

import { useContextualizedFields } from '../../hooks/useContextualizedFields.hook';

import { useResolvableServiceUsagesFieldArrayRenderer } from './hooks/useFieldArrayRenderer.hook';
import type { GroupProps } from './types/props.type';
import type { ResolvableServiceUsagesContext } from './types/context.type';

type ContextualizedFields = Readonly<
  Pick<ResolvableServiceUsagesContext, 'serviceUsages'>
>;

export const ResolvableServiceUsagesGroupFormStep = (
  props: Readonly<GroupProps>,
) => {
  const { fieldArrayRender } =
    useResolvableServiceUsagesFieldArrayRenderer(props);

  const { formContext } = props;

  const fields = useContextualizedFields<ContextualizedFields>(
    {
      serviceUsages: {
        id: 'service-usages',
        name: 'serviceUsages',
      },
    },
    formContext,
  );

  return (
    <FieldArray name={fields.serviceUsages.name} render={fieldArrayRender} />
  );
};
